module.exports = __webpack_public_path__ + "RahulHansda-3f463414.webp";